<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-form v-model="valid">
                <v-card-title class="brand onBrand--text">
                    <span class="headline">Resolve Issue</span>
                </v-card-title>

                <v-card-text>
                    <!-- <v-container> -->
                    <v-row justify="center">
                        <v-col cols="12" sm="4" md="4">
                            Section
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" dense rounded required outlined item-value="section_id"
                                v-model="section" :items="section_array_list" item-text="section_name"
                                label="Maintenance Section" persistent-hint hint=" Select  Section" />
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" sm="4" md="4">
                            Status
                            <v-icon color="error">*</v-icon>
                            <v-autocomplete color="#0F2027" outlined dense rounded required item-value="status_id"
                                v-model="statuss" :items="status_array_list" item-text="status_name"
                                label="Maintenance Status" persistent-hint hint=" Select Status" />
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-radio-group row v-model="radio">
                            <v-radio label="All" value="all"></v-radio>
                            <v-radio label="Date Range" value="daterange"></v-radio>
                        </v-radio-group>
                        <div v-if="this.radio == 'daterange'">
                            <v-card shaped elevation="4">
                                <br />
                                <v-col cols="12" sm="12" md="12">
                                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date" label="Select From Date"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date" scrollable>
                                            <v-spacer></v-spacer><v-btn text color="primary"
                                                @click="modal = false">Cancel</v-btn> <v-btn text color="primary"
                                                @click="$refs.dialog.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-dialog ref="dialog2" v-model="modal2" :return-value.sync="date2" persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs2 }">
                                            <v-text-field v-model="date2" label="Select To Date"
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs2"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date2" scrollable>
                                            <v-spacer></v-spacer><v-btn text color="primary"
                                                @click="modal2 = false">Cancel</v-btn> <v-btn text color="primary"
                                                @click="$refs.dialog2.save(date2)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-card>
                        </div>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="2" sm="2" md="2">
                            <v-btn class="mt-6 button" @click="fetchIssue()">Fetch</v-btn>
                        </v-col>
                    </v-row>
                    <!-- </v-container> -->
                </v-card-text>
            </v-form>
        </v-card>

        <v-card class="box" v-if="issue_traking_table_list!=''">
            <v-col cols="12" sm="3" md="3">
                <v-btn color="success" outlined rounded v-if="issue_traking_table_list!= ''">
                    <download-excel class="mr-2 pb-3 pt-2" :data="issue_traking_table_list" :fields="table_fields"
                        worksheet="resolve_issue" name="resolve_issue.xls"> <v-icon dark>mdi-file-excel</v-icon> Export
                    </download-excel>
                </v-btn>
            </v-col>

            <v-data-table :headers="headers" :items="issue_traking_table_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Resolve Issue</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <!-- <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                
              </template> -->
                        <!-- <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn
                      class="mb-2 button"
                      color="primary"
                      @click="save"
                      :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card> -->
                        <!-- </v-dialog> -->
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar size="35">
                            <v-icon class="mr-4 v-icon-size" color="primary"
                                @click="editIssue(item)">mdi-open-in-new</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
                <template v-slot:item.file="{ item }">
                    <span v-if="item.file != ''">
                        <a class="p-2" :href="awspath + item.file" target="blank">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                            color="primary">mdi-eye</v-icon></v-btn>
                                </template>
                                <span> View File</span>
                            </v-tooltip>
                        </a>
                    </span>
                    <span v-else> -- </span>
                </template>
            </v-data-table>
        </v-card>
        <v-row justify="center">
            <v-dialog v-model="fullscreendialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Issue</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="6" style="border-style: solid;">
                                <v-simple-table class="myStyledTable">
                                    <template v-slot:default>
                                        <tr>
                                            <th>Issue</th>
                                            <td>{{ editedItem.issue }}</td>
                                        </tr>
                                        <tr>
                                            <th>Section</th>
                                            <td>{{ editedItem.sectiontable }}</td>
                                        </tr>
                                        <tr>
                                            <th>Description</th>
                                            <td>
                                                <v-textarea outlined v-model="editedItem.description"
                                                    disabled></v-textarea>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Issue By</th>
                                            <td>{{ editedItem.issueby }}</td>
                                        </tr>
                                        <tr>
                                            <th>Post Date</th>
                                            <td>{{ editedItem.postdate }}</td>
                                        </tr>
                                        <tr>
                                            <th>Room No.</th>
                                            <td>{{ editedItem.room }}</td>
                                        </tr>
                                        <tr>
                                            <th>File</th>
                                            <td>
                                                <a v-if="editedItem.file != ''" class="p-2"
                                                    :href="awspath + editedItem.file" target="blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                                    color="primary">mdi-file</v-icon></v-btn>
                                                        </template>
                                                        <span> View File</span>
                                                    </v-tooltip>
                                                </a>
                                                <span style="color: red; font-size: 14px; font-style: italic;"
                                                    v-else>file not uploaded!</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <!-- <td>{{ editedItem.status }}</td> -->
                                            <td>
                                                <v-col>
                                                    <v-autocomplete color="#0F2027" outlined dense rounded required
                                                        v-model="editedItem.status" :items="status_array_list"
                                                        item-text="status_name" />
                                                </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Action By</th>
                                            <!-- <td>{{ editedItem.actionby }}</td> -->
                                            <td>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete rounded outlined dense v-model="editedItem.actionby"
                                                        :items="staff_list" return-object item-text="staff_name"
                                                        item-value="id" />
                                                </v-col>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Action Date</th>
                                            <!-- <td>{{ editedItem.actiondate }}</td> -->
                                            <v-col cols="12" sm="12" md="12">
                                                <v-dialog ref="dialog3" v-model="modal3"
                                                    :return-value.sync="editedItem.actiondate" persistent width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="editedItem.actiondate"
                                                            label="Select Date" prepend-icon="mdi-calendar" readonly
                                                            v-bind="attrs" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-date-picker :max="nowDate" v-model="editedItem.actiondate"
                                                        scrollable>
                                                        <v-spacer></v-spacer><v-btn text color="primary"
                                                            @click="modal3 = false">Cancel</v-btn> <v-btn text
                                                            color="primary"
                                                            @click="$refs.dialog3.save(editedItem.actiondate)">OK</v-btn>
                                                    </v-date-picker>
                                                </v-dialog>
                                            </v-col>
                                        </tr>
                                        <tr>
                                            <th>Remark</th>
                                            <!-- <td>{{ editedItem.remark }}</td> -->
                                            <td>
                                                <v-textarea outlined name="input-7-4" v-model="editedItem.remark"
                                                    label="Enter Remark"></v-textarea>
                                            </td>
                                        </tr>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="2" sm="2" md="2">
                                <v-btn :disabled="editedItem.status_edit!='Inprocess'" color="primary" class="button"
                                    @click="updateIssue()">Save</v-btn>
                                <!-- <v-btn color="primary" class="button" @click="updateIssue()">Save</v-btn> -->
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            overlay: false,
            // extraBreadcrumbItems: [
               

            // ],
            // breadcrumbClass: "breadcrumb-style2",
            // errorMsg: {
            //   name: false,
            // },
            nowDate: new Date().toISOString().slice(0, 10),
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            date: "",
            date2: "",
            date3: "",
            radio: "",
            section: "",
            statuss: "",
            modal: false,
            modal2: false,
            modal3: false,
            status_array_list: "",
            awspath: null,
            editedItem: [],
            editedstatus: "",
            editedstaff: "",
            editedremark: "",
            fetched_issue_list: "",
            table_fields: {
                "Sr no.": "srno",
                Issue: "issue",
                "Issue By": "issueby",
                "Action By": "action_by",
                "Post Date": "postdate",
                Section:"sectiontable",
                Room:"room",
                Description:"description"
                },
            headers: [
                { text: "Sr. No.", sortable: false, value: "srno" },
                { text: "Issue", align: "center", sortable: false, value: "issue" },
                { text: "Issue By", align: "center", sortable: false, value: "issueby" },
                { text: "Action By", align: "center", sortable: false, value: "action_by" },
                {
                    text: "Post Date",
                    align: "center",
                    sortable: false,
                    value: "postdate",
                },
                {
                    text: "Section",
                    align: "center",
                    sortable: false,
                    value: "sectiontable",
                },
                { text: "Room", align: "center", sortable: false, value: "room" },
                {
                    text: "File",
                    align: "center",
                    sortable: false,
                    value: "file",
                },
                {
                    text: "Description",
                    align: "center",
                    sortable: false,
                    value: "description",
                },
                {
                    text: "Status",
                    align: "center",
                    sortable: false,
                    value: "status",
                },
                {
                    text: "Action",
                    align: "center",
                    sortable: false,
                    value: "action",
                },
            ],
            status_array_list: [],
            section_array_list: [],
            issue_traking_table_list: [],
            fetched_issue_list: [],
            staff_list: [],
            editedIndex: -1,
            fullscreendialog: false,
        }),
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onLoad();
        },
        methods: {
            close() {
                this.fullscreendialog = false;
                this.editedremark = "";
                this.editedstaff = "";
                this.editedstatus = "";
                this.date3 = "";
            },
            updateIssue() {
                // console.log("inside updateIssue");
                
                let data = {
                    maintenance_id: this.editedItem.id,
                    remark: this.editedItem.remark,
                    date: this.editedItem.actiondate,
                    instructor: this.editedItem.actionby,
                    status: this.editedItem.status,
                };
                axios
                    .post("/MaintenanceSystem/editResolveIssue", data)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Issue updated successfully...");
                            this.fullscreendialog = false;
                            this.date3 = "";
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            editIssue(item) {
                // console.log({ item });
                this.fullscreendialog = true;
                this.editedItem = item;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/MaintenanceSystem/getResolveIssue")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            this.status_array_list = res.data.status_array_list;
                            this.section_array_list = res.data.section_array_list;
                             if (this.section_array_list.length == 0) {
                                this.showSnackbar("#b71c1c", "No Section mapped!!!"); // show snackbar
                            }
                            // this.issue_traking_table_list = res.data.fetched_issue_list;
                            this.staff_list = res.data.staff_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            fetchIssue() {
                if (this.section.length == 0) {
                    this.showSnackbar("#b71c1c", "Please select Section..."); // show snackbar
                    return;
                }
                if (this.statuss.length == 0) {
                    this.showSnackbar("#b71c1c", "Please select Status..."); // show snackbar
                    return;
                }
                if (this.radio.length == 0) {
                    this.showSnackbar("#b71c1c", "Please select All or Date Range!"); // show snackbar
                    return;
                }

                const data = {
                    section: this.section,
                    statuss: this.statuss,
                    radio: this.radio,
                    date: this.date,
                    date2: this.date2,
                };
                axios
                    .post("/MaintenanceSystem/fetchResolveIssue", data)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Records founds...");
                            this.issue_traking_table_list = res.data.fetched_issue_list;
                            //  window.console.log(res.data.fetched_issue_list);
                            if (this.issue_traking_table_list.length == 0) {
                                this.showSnackbar("#b71c1c", "No Issue Record found!"); // show snackbar
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .myStyledTable td {
        font-size: 16px;
    }
    .myStyledTable th {
        font-size: 16px;
        font-weight: bold;
    }
</style>
